/**
 * Maps the renderer's `DatabaseEngineId` to the grammar's `SqlEngine`. The
 * two unions differ in two ways: `pgsql` ↔ `postgres`, and `mock` has no
 * grammar mapping. The version-gating modules consume `SqlEngine`; the
 * orchestrator + Monaco wiring consume `DatabaseEngineId`. This helper is
 * the single conversion point.
 */

import type { DatabaseEngineId } from '@/core/engines';
import type { SqlEngine } from '@/features/sql-grammar/parseOptions';

export function databaseEngineIdToSqlEngine(id: DatabaseEngineId): SqlEngine | undefined {
  switch (id) {
    case 'mssql':
      return 'mssql';
    case 'pgsql':
      return 'postgres';
    case 'mysql':
      return 'mysql';
    case 'oracle':
      return 'oracle';
    case 'sqlite':
      return 'sqlite';
    case 'mock':
      return undefined;
  }
}
